import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Map from '../views/Map.vue'
import MileStone from '../views/MileStone.vue'
import Login from '../views/Login.vue'
import StrategyDashboard from '../views/StrategyDashboard.vue'
import GeneralDashboard from '../views/GeneralDashboard.vue'
import MaintenanceSchedule from '../views/MaintenanceSchedule.vue'
import ExcelAnalyse from '../views/ExcelAnalyse.vue'

Vue.use(VueRouter)

const routes = [
  
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '',
    name: 'Map',
    component: Map,
    beforeEnter (to, from, next){
      Auth(to, from, next);
    }
  },
  {
    path: '/strategydashboard',
    name: 'StrategyDashboard',
    component: StrategyDashboard,
    beforeEnter (to, from, next){
      Auth(to, from, next);
    },
  },
  {
    path: '/generaldashboard',
    name: 'GeneralDashboard',
    component: GeneralDashboard,
    beforeEnter (to, from, next){
      Auth(to, from, next);
    },
  },
  {
    path: '/milestone',
    name: 'Milestone',
    component: MileStone,
    beforeEnter (to, from, next){
      Auth(to, from, next);
    },
  },
  {
    path: '/maintenanceschedule',
    name: 'MaintenanceSchedule',
    component: MaintenanceSchedule,
    beforeEnter (to, from, next){
      Auth(to, from, next);
    },
  },
  {
    path: '/excelanalyse',
    name: 'ExcelAnalyse',
    component: ExcelAnalyse,
    beforeEnter (to, from, next){
      Auth(to, from, next);
    },
  }


]

const router = new VueRouter({
  routes
})

function Auth(to, from, next){
  if(store.state.session){
    next();    
  }
  else{
    next({name: 'Login'}); 
  } 
}

export default router
